import Vue from 'vue'
import Component from 'vue-class-component'

/**
 * プロジェクト共通で使用する辞書定義.
 */
@Component
export class Dictionary extends Vue {
    getPlan(plan: string) {
        switch (plan) {
          case "free": 
            return "個人プラン"
          case "business_basic":
            return "法人向け Basicプラン"
          case "business_advanced":
            return "法人向け Advancedプラン"
          case "broadcaster":
            return "法人向け Broadcastプラン"
          default:
            return "不明"
        }
    }

    getPaymentMethond(method: string) {
        switch (method) {
            case "bank_transfer":
                return "銀行振り込み"
            default:
                return "不明"
        }
    }
}